import { toRGBA } from "./utils";

const getCloseButton = ({ closeBtnInnerPost, closeButton }) => {
  const {
    size,
    marginLeft,
    marginTop,
    marginBottom,
    marginRight,
    color,
    strokeWidth,
    borderColor,
    backgroundColor,
  } = closeButton;
  return `
    <div
      style="
        position: absolute;
        top: ${closeBtnInnerPost}px;
        right: ${closeBtnInnerPost}px;
        width: ${size}px;
        height: ${size}px;
        margin-top: ${marginTop}px;
        margin-right: ${marginRight}px;
        margin-bottom: ${marginBottom}px;
        margin-left: ${marginLeft}px;
        outline: none;
        cursor: pointer;
      "
    >
      <div
        class="rip-mm-teaser-close-button"
        style="
          background-color: ${toRGBA(backgroundColor)};
          border-radius: 50%;
          display: flex;
          width: ${size}px;
          height: ${size}px;
          border: 1px solid ${toRGBA(borderColor)};
        "
      >
        <svg
          viewBox="-2.4 -1 28.80 28.80"
          fill="none"
          stroke="${toRGBA(color)}"
          stroke-width="${strokeWidth}"
          width="${size}"
          height="${size}"
        >
          <g stroke-width="0"></g>
          <g
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke="${toRGBA(color)}"
            stroke-width="0.048"
          ></g>
          <g>
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z"
              fill="${toRGBA(color)}"
            ></path>
          </g>
        </svg>
      </div>
    </div>
  `;
};

const getTopLeft = ({
  size,
  padding,
  closeBtnOffset,
  content,
  innerWidth,
  innerHeight,
  closeBtnInnerPost,
  closeButton,
}) => {
  return `
    <div
      class="rip-mm-teaser rip-mm-teaser-corner animate__animated animate__fadeInTopLeft"
      style="width: ${size}px; height: ${size}px;position: fixed;top: 0;left: 0;overflow:hidden;z-index:333;"
    > 
      <div style="position: absolute; right: ${closeBtnOffset}px; bottom: ${closeBtnOffset}px;">
        ${getCloseButton({ closeBtnInnerPost, closeButton })}
      </div>
      <div
        class="rip-mm-teaser-button"
        data-pisition="topLeft"
        style="
          cursor: pointer;
          width: ${innerWidth}px;
          height: ${innerHeight}px;
          background: white;
          transform: rotate(-45deg);
          transform-origin: left top 0px;
          position: relative;
          box-shadow: rgb(204, 204, 204) 0px 0px 5px;
          display: flex;
          top: ${size / 2}px;
          left: -${size / 2}px;
          flex-direction: column-reverse;
          align-items: center;
        "
      >
        <div style="padding: ${padding}px;">
          ${content}
        </div>
      </div>
    </div>
  `;
};

const getTopRight = ({
  size,
  padding,
  closeBtnOffset,
  content,
  innerWidth,
  innerHeight,
  closeBtnInnerPost,
  closeButton,
}) => {
  return `
  <div
      class="rip-mm-teaser rip-mm-teaser-corner animate__animated animate__fadeInTopRight"
      style="width: ${size}px; height: ${size}px;position: fixed;top: 0;right:0;overflow: hidden;z-index:333;"
    >
      <div style="position: absolute; left: ${closeBtnOffset}px; bottom: ${closeBtnOffset}px;">
        ${getCloseButton({ closeBtnInnerPost, closeButton })}
      </div>
      <div
        class="rip-mm-teaser-button"
        data-pisition="topRight"
        style="
          cursor: pointer;
          width: ${innerWidth}px;
          height: ${innerHeight}px;
          background: white;
          transform: rotate(45deg);
          transform-origin: left top 0px;
          position: relative;
          top: -${size / 2}px;
          box-shadow: rgb(204, 204, 204) 0px 0px 5px;
          display: flex;
          left: ${size / 2}px;
          flex-direction: column-reverse;
          align-items: center;
        "
      >
        <div style="padding: ${padding}px;">
          ${content}
        </div>
      </div>
    </div>
  `;
};

const getBottomLeft = ({
  size,
  padding,
  closeButtonDistance,
  content,
  innerWidth,
  innerHeight,
  closeBtnOffset,
  closeBtnInnerPost,
  closeButton,
}) => {
  return `
    <div
      class="rip-mm-teaser rip-mm-teaser-corner animate__animated animate__fadeInBottomLeft"
      style="width: ${size}px; height: ${size}px;position:fixed;bottom:0;left:0;overflow:hidden;z-index:333;"
    >
      <div style="position: absolute; right: ${closeBtnOffset}px; top:${closeBtnOffset}px;">
        ${getCloseButton({ closeBtnInnerPost, closeButton })}
      </div>
      <div
        class="rip-mm-teaser-button"
        data-pisition="bottomLeft"
        style="
          cursor: pointer;
          width: ${innerWidth}px;
          height: ${innerHeight}px;
          background: white;
          transform: rotate(45deg);
          transform-origin: left top 0px;
          position: relative;
          box-shadow: rgb(204, 204, 204) 0px 0px 5px;
        "
      >
        <div style="padding: ${padding}px;">
          ${content}
        </div>
      </div>
    </div>
  `;
};

const getBottomRight = ({
  size,
  padding,
  closeBtnOffset,
  content,
  innerWidth,
  innerHeight,
  closeBtnInnerPost,
  closeButton,
}) => {
  return `
    <div
      class="rip-mm-teaser rip-mm-teaser-corner animate__animated animate__fadeInBottomRight"
      style="width: ${size}px; height: ${size}px;position: fixed;bottom: 0;right:0;z-index:333;"
    >
      <div style="position: absolute; top: ${closeBtnOffset}px; left: ${closeBtnOffset}px;">
        ${getCloseButton({ closeBtnInnerPost, closeButton })}
      </div>
      <div
        class="rip-mm-teaser-button"
        data-pisition="bottomRight"
        style="
          cursor: pointer;
          width: ${innerWidth}px;
          height: ${innerHeight}px;
          background: white;
          transform: rotate(-45deg);
          transform-origin: left top;
          position: relative;
          top: ${size}px;
          box-shadow: rgb(204, 204, 204) 0px 0px 5px;
        "
      >
        <div style="padding: ${padding}px;">
          ${content}
        </div>
      </div>
    </div>
  `;
};

export default (treeData, preview = false) => {
  const { closeButton, teaser } = treeData.root.extraComponents;

  const { size, closeButtonDistance, content, position, padding } = teaser.data;
  const { size: closeBtnSize } = closeButton.data;

  const innerHeight = Math.sqrt((size * size) / 2);
  const innerWidth = Math.sqrt(size * size * 2);

  const distance = innerHeight - closeButtonDistance;

  const closeBtnOffset = Math.sqrt((distance * distance) / 2);
  const closeBtnInnerPost = -closeBtnSize / 2;

  let htmlContent = "";
  if (position === "top-left") {
    htmlContent = getTopLeft({
      size,
      padding,
      closeButtonDistance,
      content,
      innerWidth,
      innerHeight,
      closeBtnOffset,
      closeBtnInnerPost,
      closeButton: closeButton.data,
    });
  } else if (position === "top-right") {
    htmlContent = getTopRight({
      size,
      padding,
      closeButtonDistance,
      content,
      innerWidth,
      innerHeight,
      closeBtnOffset,
      closeBtnInnerPost,
      closeButton: closeButton.data,
    });
  } else if (position === "bottom-left") {
    htmlContent = getBottomLeft({
      size,
      padding,
      closeButtonDistance,
      content,
      innerWidth,
      innerHeight,
      closeBtnOffset,
      closeBtnInnerPost,
      closeButton: closeButton.data,
    });
  } else if (position === "bottom-right") {
    htmlContent = getBottomRight({
      size,
      padding,
      closeButtonDistance,
      content,
      innerWidth,
      innerHeight,
      closeBtnOffset,
      closeBtnInnerPost,
      closeButton: closeButton.data,
    });
  }

  return `
    <style>
    .rip-mm-teaser p {
      margin: 0;
    }
    </style>
    ${htmlContent}
  `;
};
